import * as React from "react";
import { forwardRef } from "react";
const SvgTagIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42z", stroke: "currentColor", strokeWidth: 2, fill: "none" }), /* @__PURE__ */ React.createElement("circle", { cx: 5.5, cy: 5.5, r: 1.5, fill: "currentColor" }));
const ForwardRef = forwardRef(SvgTagIcon);
export { ForwardRef as ReactComponent };
